import { render, staticRenderFns } from "./onlinestatus.vue?vue&type=template&id=57542960&"
import script from "./onlinestatus.vue?vue&type=script&lang=ts&"
export * from "./onlinestatus.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports